import { useMessage } from '/@/hooks/web/useMessage';
import { onMounted, onUnmounted } from 'vue';
import { useAppStore } from '/@/store/modules/app';
import { useI18n } from '@mcex/locale';
export const useInitSysSetting = () => {
  const appStore = useAppStore();

  onMounted(() => {
    appStore.setProjectConfig({
      fullContent: false,
    });
  });

  const { createWarningModal } = useMessage();
  const { t } = useI18n();
  let modal: Nullable<ReturnType<typeof createWarningModal>> = null;
  const updateWebNotice = (_e) => {
    if (modal) {
      modal.destroy();
    }
    // 提示用户更新
    modal = createWarningModal({
      iconType: 'warning',
      title: t('sys.updateTitle'),
      content: t('sys.updateDescription'),
      okText: t('sys.updateNow'),
      onOk: async () => {
        window.location.reload();
      },
    });
  };
  const checkWebUpdate = (event) => {
    if (event.target && (event.target.tagName === 'SCRIPT' || event.target.tagName === 'LINK')) {
      window.pluginWebUpdateNotice_?.checkUpdate();
    }
  };
  onMounted(() => {
    document.body.addEventListener('plugin_web_update_notice', updateWebNotice);
    window.addEventListener('error', checkWebUpdate, true);
  });
  onUnmounted(() => {
    document.body.removeEventListener('plugin_web_update_notice', updateWebNotice);
    window.removeEventListener('error', checkWebUpdate, true);
  });
};
